<template>
  <div
    class="regulatory-contract"
    v-loading="isLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    >
    </SiruiSearch>
    <!--内容区域-->
    <vxe-toolbar style="margin-top: 10px">
      <template v-slot:buttons>
        <div style="min-width: 1200px">
          <div class="btnContainer" style="border: 1px dashed red">
            <span>第一次付款按钮</span>
            <el-button size="medium" type="primary" style="margin-left: 5px" @click="firstClick()"
              >第一次导入</el-button
            >
            <el-button size="medium" type="primary" @click="newImport()">重新导入</el-button>
            <el-button size="medium" type="primary" @click="sendJinDie()">发送金蝶</el-button>
          </div>
          <div class="btnContainer" style="border: 1px dashed red; margin-left: 5px">
            <span>有准确数据后重新入库</span>
            <el-button
              size="medium"
              type="primary"
              style="margin-left: 5px"
              @click="chargeAgainst()"
              >冲销</el-button
            >
            <el-button size="medium" type="primary" @click="newStorage()">重新入库</el-button>
          </div>
          <div class="btnContainer" style="border: 0px dashed red; margin-left: 5px">
            <el-button size="medium" type="primary" @click="exportExcel()">导出</el-button>
          </div>
        </div>
      </template>
    </vxe-toolbar>
    <div class="main-content">
      <vxe-table
        ref="siruiTable"
        border
        resizable
        size="mini"
        :height="$store.state.app.tableHeight"
        :loading="loadingTable"
        :data="tableData"
        :tooltip-config="{ theme: 'dark' }"
        show-overflow
        auto-resize
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.prop"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'dataState'">{{
              dataStateList[row[item.field]]
            }}</template>
            <template v-else-if="item.field === 'kingdeeState'">{{
              row.kingdeeState == 0 ? '未发送' : '已发送'
            }}</template>
            <template v-else-if="item.field === 'fileDescription'">
              <i
                class="el-icon-edit"
                style="cursor: pointer"
                @click="fileClickEvent(row, item.field)"
              ></i>
              {{ row[item.field] }}
            </template>
            <template v-else-if="item.field === 'matchingFailFile' || item.field === 'fileLink'">
              <el-button v-if="row[item.field]" type="text" @click="downExcel(row, item.field)">
                文件下载
              </el-button>
              <span v-else></span>
            </template>
            <template v-else-if="['operationTime', 'kingdeeTime'].includes(item.field)">
              {{ momentTime(row[item.field]) }}
            </template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </vxe-table>
      <SiruiPagination
        :page.sync="page"
        :selectLength="multipleSelection.length"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </div>
    <!-- 文件描述 -->
    <EditFileDEscribeDialog
      ref="editFileDEscribeDialogRef"
      @saveHandler="saveFileHandler"
    ></EditFileDEscribeDialog>
    <!-- 导入弹窗 -->
    <SiruiUpload
      :action="action"
      @getData="getTableData"
      :isShowDownTemplateBtn="fileUploadType == 'first'"
      ref="SiruiUpload"
      :data="{ ...token }"
    ></SiruiUpload>
  </div>
</template>

<script>
  import { searchFormColumns, baseColumnListDefault } from './index.js';
  import supplyDetailApi from '@/api/purchaseSalesCenter/supplyDetail.js';
  import { getUserCompanyList } from '@/common/js/util';
  import EditFileDEscribeDialog from '../components/editFileDEscribeDialog.vue';
  import moment from 'moment';
  import API from '@/api/dataBase';
  import SiruiUpload from '@/components/SiruiUpload';
  import SiruiPagination from '@/components/SiruiPagination';
  export default {
    name: 'supplyDetailImport',
    data() {
      return {
        tableData: [],
        multipleSelection: [], // 表格被选中的行数据
        checkRowKeys: [],
        menuButtonList: [], // 表格功能按钮
        query: {
          warehousingCompany: '',
          warehousingCompanyCode: '',
          operationDepartment: '',
          operationDepartmentCode: '',
          projectName: '',
          projectNumber: null,
          companyStatus: '',
          documenter: null,
          departmentName: '',
          fileDescription: '',
          operationTime: '',
          putOrOut: '1',
        },
        columnList: baseColumnListDefault,
        loadingTable: false,
        isLoading: true,
        companyList: [],
        departmentList: [],
        action: '',
        fileUploadType: '', // first newImport newStorage 判断文件上传类型，用于token中添加id
        page: {
          pages: 1, //总共多少页
          pageNum: 1, //第几页
          pageSize: 20, //一页多少条数据
          total: 0, //总共多少条
        },
        dataStateList: {
          0: '暂估入库',
          1: '冲销',
          2: '重新入库',
        },
      };
    },
    computed: {
      //表单字段
      searchColumns() {
        return searchFormColumns(this);
      },
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
          ...(this.fileUploadType == 'newImport' || this.fileUploadType == 'newStorage'
            ? { id: this.multipleSelection[0].id }
            : {}),
          ...(this.fileUploadType == 'newStorage'
            ? { settleBatchNo: this.multipleSelection[0].uniqueIdentificationNumber }
            : {}),
        };
      },
    },
    async mounted() {
      this.companyList = await getUserCompanyList();
      // this.departmentList = await this.getDepartment(this.userInfo.companyCode);
      // this.query.warehousingCompanyCode = this.userInfo.companyCode;
      // this.query.operationDepartmentCode = this.userInfo.departmentCode;
      // this.query.warehousingCompany = this.userInfo.companyName;
      // this.query.operationDepartment = this.userInfo.departmentName;
      this.getTableData();
    },
    methods: {
      // 时间戳转换
      momentTime(val) {
        if (val) {
          return moment(val).format('YYYY-MM-DD HH:mm:ss');
        }
        return '';
      },
      // 第一次导入
      firstClick() {
        this.$confirmAction('提示', `Excel中尽量避免使用公式计算出现精度丢失`)
          .then(() => {
            this.action = supplyDetailApi.FIRST_IMPORT;
            this.fileUploadType = 'first';
            this.$refs.SiruiUpload.openDialog(true, '108');
          })
          .catch(() => {
            this.fileUploadType = '';
            console.log('取消');
          });
      },
      // 重新导入
      newImport() {
        let isOneSelect = this.judgeOneSelect();
        if (isOneSelect) {
          // 校验数据是否为未发送
          if (this.checkSelectListJinDieStatus()) {
            return this.$message.error('请先选择未发送金蝶的数据再进行操作');
          }
          this.$confirmAction('提示', `是否确定重新导入该条数据？请确定选择模板正确`)
            .then(() => {
              this.fileUploadType = 'newImport';
              this.action = supplyDetailApi.NEW_IMPORT;
              this.$refs.SiruiUpload.openDialog(true, '108');
            })
            .catch(() => {
              this.fileUploadType = '';
              console.log('取消');
            });
        }
      },
      // 发送金蝶
      async sendJinDie() {
        if (this.multipleSelection.length != 1) {
          return this.$message.error('请先选择一条数据再进行操作');
        }
        if (this.checkSelectListJinDieStatus()) {
          return this.$message.error('请先选择未发送金蝶的数据再进行操作');
        }
        let params = {
          id: this.multipleSelection[0].id,
          uniqueIdentificationNumber: this.multipleSelection[0].uniqueIdentificationNumber,
        };
        const { data } = await this.$axios.post(supplyDetailApi.SEND_JINDIE, params);
        if (data.code == 0) {
          this.$message.success(data.msg);
          this.getTableData();
        } else {
          this.$message.error(data.msg);
        }
      },
      checkSelectListJinDieStatus() {
        return this.multipleSelection.filter((v) => v.kingdeeState != 0).length != 0;
      },
      // 冲销
      chargeAgainst() {
        let isOneSelect = this.judgeOneSelect();
        if (isOneSelect) {
          this.$confirmAction('提示', `是否确定冲销该条数据`)
            .then(() => {
              const row = this.multipleSelection[0];
              this.loading.startLoading();
              this.$axios
                .post(supplyDetailApi.WRITE_OFF, {
                  id: row.id,
                  uniqueIdentificationNumber: row.uniqueIdentificationNumber,
                })
                .then((res) => {
                  if (res.data.code == 0) {
                    this.$message.success('操作成功');
                    this.loading.endLoading();
                    this.resetBtnClick();
                  } else {
                    this.loading.endLoading();
                    this.$message.error(res.data.msg);
                  }
                })
                .catch(() => this.loading.endLoading());
            })
            .catch(() => {
              console.log('取消');
            });
        }
      },
      // 重新入库
      newStorage() {
        let isOneSelect = this.judgeOneSelect();
        if (isOneSelect) {
          this.$confirmAction('提示', `是否确定重新入库该条数据？请确定选择模板正确`)
            .then(() => {
              this.fileUploadType = 'newStorage';
              this.action = supplyDetailApi.NEW_STORAGE;
              this.$refs.SiruiUpload.openDialog(true, '108');
            })
            .catch(() => {
              this.fileUploadType = '';
              console.log('取消');
            });
        }
      },
      // 导出
      exportExcel() {
        if (this.tableData.length == 0) {
          this.$message.error('暂无数据');
          return;
        }
        const { pageNum, pageSize } = this.page;
        this.query.pageNum = pageNum;
        this.query.pageSize = pageSize;
        this.exportLoading = true;
        this.$axios.post(supplyDetailApi.EXPORT_LOG, this.filterEmpty(this.query)).then((res) => {
          this.exportLoading = false;
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      judgeOneSelect() {
        if (this.multipleSelection.length != 1) {
          this.$message.error('请选择一条数据操作');
          return false;
        }
        return true;
      },
      // 文件下载
      async downExcel(row, prop) {
        window.location.href = row[prop];
      },
      async saveFileHandler({ id, fileDescription }) {
        const { data } = await this.$axios.post(supplyDetailApi.EDIT_FILE_DESCRIBE, {
          id,
          fileDescription,
        });
        if (data.code == 0) {
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
        this.getTableData();
      },
      changeMethod({ val, prop }) {
        console.log(val, prop);
        if (prop == 'warehousingCompanyCode') {
          this.query.warehousingCompany = this.companyList.find((item) => item.value == val)?.label;
          this.query.operationDepartmentCode = null;
          this.query.operationDepartment = null;
          this.getDepartment(val);
        } else if (prop == 'projectName') {
          this.query.projectName = val[0].projectName;
        } else if (prop == 'operationDepartmentCode') {
          this.query.operationDepartmentCode = val;
          this.query.operationDepartment = this.departmentList.find(
            (item) => item.personDepartmentCode == val
          )?.personDepartmentName;
        }
      },
      async getDepartment(companyCode) {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        };
        this.$axios.post(API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      handleSelectionChange(row) {
        console.log(row, '选择行');
        this.multipleSelection = row.selection;
      },
      fileClickEvent(row, field) {
        if (field == 'fileDescription') {
          this.$refs.editFileDEscribeDialogRef.openDialog(row.id, row['fileDescription']);
        }
      },
      // 搜索
      searchBtnClick() {
        this.getTableData();
      },
      // 重置
      resetBtnClick() {
        this.page.pages = 1;
        this.page.pageSize = 10;
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.getTableData();
      },

      // 分页条数改变
      handleSizeChange() {
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      // putOrOut(0-出库，1-入库)
      async getTableData() {
        this.isLoading = true;
        const postData = {
          ...this.filterEmpty(this.query),
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
        };
        const { data } = await this.$axios.post(supplyDetailApi.QUERY_TABLEDATA, postData);
        this.isLoading = false;
        if (data.code == 0) {
          this.page.total = data.data.total;
          this.tableData = data.data.records;
        } else {
          this.tableData = [];
          this.$message.error('查询表格数据失败');
        }
      },
      // 点击分页
      handlePagination(val) {
        this.page.pageNum = val;
        this.getTableData();
      },
    },
    components: { EditFileDEscribeDialog, SiruiUpload, SiruiPagination },
  };
</script>

<style lang="scss" scoped>
  .btnContainer {
    padding: 5px;
    width: auto;
    display: inline-block !important;
  }
</style>
